var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipmentsFilledV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48931_2060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8766 4.47742C11.8766 4.47742 12.3672 5.1977 12.3672 5.63V9.94356V14.2571H3.91992V4H10.6921C11.1364 4 11.8766 4.47742 11.8766 4.47742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3672 14.2571H3.91992V4H10.6921C11.1364 4 11.8766 4.47742 11.8766 4.47742C11.8766 4.47742 12.3672 5.1977 12.3672 5.63V9.94356C12.3672 11.6281 12.3672 14.2571 12.3672 14.2571ZM12.3672 14.2571H16.5549",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7464 14.0175C18.584 14.1703 18.3638 14.2562 18.1341 14.2562H12.5V7.5C12.5 7.5 15.0809 7.49983 15.2106 7.5C15.3404 7.50017 15.4685 7.5278 15.5854 7.58085C15.7023 7.63389 15.8051 7.71099 15.8861 7.80644L17.9014 9.70424L18.8095 10.7727C18.9325 10.9169 18.9997 11.0963 19.0001 11.2812V13.4412C19.0001 13.6573 18.9088 13.8646 18.7464 14.0175Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5542 15.0723C16.5542 15.9725 15.7332 16.7023 14.7205 16.7023C13.7077 16.7023 12.8867 15.9725 12.8867 15.0723",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40579 15.0723C8.40579 15.9725 7.58479 16.7023 6.57203 16.7023C5.55928 16.7023 4.73828 15.9725 4.73828 15.0723",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.81641 7.08203H4.26141",
    stroke: "#3A3A40",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9.8811L4.26001 9.8811",
    stroke: "#3A3A40",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.81641 7.08203H4.26141",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9.88086L4.26001 9.88086",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48931_2060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentsFilledV2);
export default __webpack_public_path__ + "static/media/shipmentsFilledV2.08cd5fc185303cc46987069a125f236f.svg";
export { ForwardRef as ReactComponent };